const initialValues = {
  activity_name: '',
  order: 0,
};
export default initialValues;
